var map = {
	"./bill_48.png": 514,
	"./cancel_48.png": 515,
	"./create_48.png": 516,
	"./delivered_48.png": 517,
	"./info_48.png": 518,
	"./label_48.png": 519,
	"./pick_48.png": 520,
	"./print_48.png": 521,
	"./return_48.png": 522,
	"./update_48.png": 523,
	"./warehouse_48.png": 524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1134;